import Logo from "../../assets/Logo.png";
import "./Navbar.css";

function Navbar() {

   
    return <>

      
<nav className="navbar bg-inverse p-5">
  <div className="container-fluid">   

      <ul className="navbar-nav">
              
        <li>
          
          <a className="nav-link" href="/">
            
            <h4><i className="bi bi-chevron-left me-4"></i> 2ª Via do Boleto</h4>

          </a>        
        </li>
               
      </ul>

      <ul className="navbar-nav">
              
        <li>
          
          <a className="nav-link disabled" >
            
            <img src={Logo} width="170px" height="90px"/>

          </a>        
        </li>
               
      </ul>

  </div>
</nav>

      
    </>


    


}

export default Navbar;